<template>
    <div>
        <form @submit.prevent="createMessage">
            <p class="text-danger" v-if="errorText">{{errorText}}</p>
            <textarea v-if="!imageUrl" :disabled="imageUrl" type="text" name="message" class="form-control"
                      placeholder="Nachricht eingeben..."
                      v-debounce=1500 v-model.lazy="newMessage" rows="3" @input="handleTyping"></textarea>

            <input type="file"
                   style="display: none"
                   ref="fileInput"
                   accept="image/*"
                   @change="onFilePicked">
            <i v-if="!newMessage && !image" class="fa fa-file-image-o" @click="onPickFile"></i>
            <i v-if="!newMessage && !image" class="fa fa-sticky-note-o" @click="showOverlay = !showOverlay"></i>
          <b v-click-outside="closeEmojiPicker">
            <i v-if="!image" class="fa fa-smile-o" @click="showEmojiPicker = !showEmojiPicker"></i>
            <picker @select="pickEmoji" :native="true" :showPreview="false" color="#304050" v-if="showEmojiPicker"
                    :style="{ position: 'absolute', bottom: '300px' }" :i18n="german"/>
          </b>
          <button class="sendButton" type="submit" name="action" v-on:submit.prevent>Absenden</button>
            <div v-if="imageUrl">
                <h3>Bildvorschau</h3>
                <img :src="imageUrl" height="150" class="preview-image">
                <div class="deleteFile" @click="deleteImage">Datei entfernen</div>
            </div>
            <ChatTemplatesOverlay @update-message="updateMessage" v-if="showOverlay && !image"
                                  :chatTemplates="chatTemplates"></ChatTemplatesOverlay>
        </form>
    </div>
</template>

<script>
    import moment from 'moment';
    import ChatTemplatesOverlay from "./ChatTemplatesOverlay";
    import { Picker } from 'emoji-mart-vue'
    import { emojiPickerGerman } from "../../common/emoji-picker/emoji-picker-i18n";
    import { v4 } from 'uuid';
    export default {
        name: 'CreateMessage',
        props: ['currentChat', 'chatTemplates'],
        components: {
            ChatTemplatesOverlay,
            Picker
        },
        data() {
            return {
                newMessage: "",
                errorText: null,
                customer: null,
                showOverlay: false,
                image: null,
                imageUrl: null,
                isTyping: false,
                showEmojiPicker: false,
                german: emojiPickerGerman
            }
        },
        watch: {
          newMessage(message){
                    if (this.isTyping){
                        this.$store.getters.getFireStore.updateTypingState(this.currentChat.clientId, this.currentChat.customerId,false);
                        this.isTyping = !this.isTyping;
                    }
          }
        },
        methods: {
            handleTyping(){
                if (!this.isTyping) {
                    this.$store.getters.getFireStore.updateTypingState(this.currentChat.clientId, this.currentChat.customerId,true);
                    this.isTyping = !this.isTyping;
                }
            },
            async createMessage() {
              let data = {
                messageId: v4(),
                senderId: this.currentChat.userId,
                receiverId: this.currentChat.customerId,
                fullEmployeeName: this.currentChat.fullEmployeeName,
                fullCustomerName: this.currentChat.fullCustomerName,
                messageText: this.newMessage,
                source: "support",
                messageType: "text",
                authorType: "support",
                timestamp: Date.now(),
                timestampHumanReadable: moment().format("DD.MM.YYYY HH:mm")
              };

              if (this.newMessage) {
                // Text message
                data.messageText = this.newMessage;
                data.messageType = "text";
                await this.$store.getters.getFireStore.createMessage(this.currentChat.clientId, this.currentChat.customerId, data);
                await this.$store.getters.getFireStore.updateTypingState(this.currentChat.clientId, this.currentChat.customerId, false)
                this.isTyping = !this.isTyping;
              } else if (this.image) {
                // Image message, store file then store message
                const { downloadURL, filename } = await this.$store.getters.getFireStore.storeFile(this.currentChat.clientId, this.currentChat.customerId, this.image);
                data.messageText = downloadURL
                data.messageType = "image";
                data.fileName = filename
                await this.$store.getters.getFireStore.createMessage(this.currentChat.clientId, this.currentChat.customerId, data);
              } else {
                // No message
                this.errorText = "Sie müssen eine Nachricht eingeben, eine Vorlage auswählen oder ein Bild zum Hochladen auswählen!";
              }

              this.resetMessage();
            },
            resetMessage() {
                this.newMessage = '';
                this.imageUrl = null;
                this.image = null;
            },
            onPickFile: function () {
                this.$refs.fileInput.click();
            },
            onFilePicked: function (event) {
                this.resetMessage();

                const files = event.target.files;

                if (files[0].name.lastIndexOf('.') <= 0) {
                    this.errorText = "Bitte fügen Sie eine valide Bilddatei hinzu!";
                    return;
                }

                let imageData = {};
                let image = files[0];
                const fileReader = new FileReader();

                fileReader.addEventListener('load', () => {
                    this.imageUrl = fileReader.result;
                    imageData.url = this.imageUrl;
                });

                fileReader.readAsDataURL(image);

                imageData.name = image.name;
                imageData.ext = image.name.slice(image.name.lastIndexOf('.'));
                imageData.object = image;

                this.image = imageData;

                // Reset file input. This way the change event gets correctly triggered again if same file is selected
                this.$refs.fileInput.value = '';
            },
            deleteImage: function () {
                this.resetMessage();
            },
            updateMessage: function (message) {
                this.newMessage = message;
            },
            pickEmoji(emoji) {
                this.newMessage += emoji.native;
                this.closeEmojiPicker();
            },
            closeEmojiPicker() {
              this.showEmojiPicker = false;

            }
        }
    }

</script>

<style>
    .deleteFile {
        color: red;
        cursor: pointer;
        font-weight: bold;
    }

    .preview-image {
        max-width: 100%;
        height: auto;
        max-height: 130px;
    }

    .fa-sticky-note-o, .fa-smile-o {
        color: #1E64FF;
        font-size: 16px;
    }
    .emoji-mart-search > input {
      color: #304050;
      background: white !important;
    }
</style>
